export class SearchResultModel {
  title: string;
  url: string;
  objecttypefound: string;
  description: string;
  additionalinfo: string;
  producttypeid: string;
  modelid: string;
  modelnumber: string;
  line: string;
  constructor(data?) {
    const searchresultData = data || {};
    this.title = searchresultData.title;
    this.url = searchresultData.url;
    this.objecttypefound = searchresultData.objecttypefound;
    this.description = searchresultData.description;
    this.additionalinfo = searchresultData.additionalInfo;
    this.line = searchresultData.line;
    this.modelid = searchresultData.modelId;
    this.producttypeid = searchresultData.productTypeID;
    this.modelnumber = searchresultData.modelNumber;
  }
}


// WEBPACK FOOTER //
// ./src/app/search-results/models/search-result.model.ts